import { render } from "./ActionDetailPage.vue?vue&type=template&id=7828d588&scoped=true"
import script from "./ActionDetailPage.vue?vue&type=script&lang=js"
export * from "./ActionDetailPage.vue?vue&type=script&lang=js"

import "./ActionDetailPage.vue?vue&type=style&index=0&id=7828d588&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7828d588"]])

export default __exports__